<template>
  <div
    v-if="visible"
    class="modal-overlay"
    @click.self="$emit('close')"
    style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5); z-index: 1050; display: flex; align-items: center; justify-content: center; padding: 1rem;">
    <div
      role="dialog"
      class="invite-sent-card"
      @click.stop
      style="pointer-events: auto; max-width: 28rem; width: 92%; background: white; border-radius: 0.75rem; padding: 0; position: relative; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); overflow: hidden;">
      <div style="padding: 1.5rem 1.5rem 1rem 1.5rem; display: flex; justify-content: space-between; align-items: flex-start;">
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" style="flex-shrink: 0;">
            <circle cx="12" cy="12" r="5.5" stroke="#16a34a" stroke-width="1.25" stroke-dasharray="29 5" stroke-dashoffset="0"/>
            <path d="M10 11l2 2 5-3.5" stroke="#16a34a" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <h3 style="font-size: 1.125rem; font-weight: 700; margin: 0; color: #16a34a;">
            {{ paymentLink ? 'Convite enviado com sucesso!' : 'Convite enviado!' }}
          </h3>
        </div>
        <button type="button" style="background: transparent; border: none; cursor: pointer; padding: 0.25rem; color: #6b7280;" @click="$emit('close')">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
        </button>
      </div>
      <div style="padding: 0 1.5rem 1.5rem 1.5rem;">
        <div style="background: #f9fafb; border-radius: 0.5rem; padding: 0.75rem 1rem; margin-bottom: 1rem; display: flex; align-items: center; gap: 0.5rem;">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" style="flex-shrink: 0;"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
          <span style="font-size: 0.875rem; color: #374151;">Um link de confirmação foi enviado para {{ email }}.</span>
        </div>

        <p v-if="vacantSeatPlan" style="font-size: 0.875rem; color: #166534; line-height: 1.45; margin: 0 0 1rem 0;">
          Usuário ativado numa licença livre do plano {{ vacantSeatPlan }} — sem cobrança.
        </p>

        <!-- Cobrança gerada: botão com o link de pagamento -->
        <template v-else-if="paymentLink">
          <p style="font-size: 0.8125rem; color: #6b7280; line-height: 1.45; margin: 0 0 0.75rem 0;">
            As funcionalidades são liberadas após o pagamento da cobrança<span v-if="amount != null"> de <strong style="color: #111827;">{{ formatCurrency(amount) }}</strong></span><span v-if="dueDate"> (vence em {{ formatDate(dueDate) }})</span>.
          </p>
          <a
            :href="paymentLink"
            target="_blank"
            rel="noopener noreferrer"
            style="display: flex; align-items: center; justify-content: center; gap: 0.5rem; width: 100%; box-sizing: border-box; margin-bottom: 1rem; padding: 0.625rem 1rem; background-color: #16a34a; color: #ffffff; border-radius: 0.5rem; font-size: 0.875rem; font-weight: 600; text-decoration: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
            Abrir link de pagamento
          </a>
        </template>

        <div style="display: flex; justify-content: flex-end;">
          <button
            type="button"
            @click="$emit('close')"
            style="display: inline-flex; align-items: center; justify-content: center; border-radius: 0.5rem; font-size: 0.875rem; font-weight: 600; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #2563eb; color: #ffffff; border: none; cursor: pointer;">
            Entendido
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from '@/utils/currency'

export default {
  name: 'InviteSuccessCard',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: ''
    },
    paymentLink: {
      type: String,
      default: ''
    },
    amount: {
      type: Number,
      default: null
    },
    dueDate: {
      type: String,
      default: null
    },
    vacantSeatPlan: {
      type: String,
      default: ''
    }
  },
  methods: {
    formatCurrency,
    formatDate (value) {
      if (!value || typeof value !== 'string') return ''
      const parts = value.slice(0, 10).split('-')
      if (parts.length !== 3) return ''
      return `${parts[2]}/${parts[1]}/${parts[0]}`
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/invite/InviteSuccessCard.vue